import { get, ref, update } from "firebase/database";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { db } from "../../configs/Firebase";

const Access = () => {
  const userStatus = useSelector((state) => state.userStatus.value);
  const [user, setUser] = useState(false);
  const [emailRef, setEmailRef] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [workspaceID, setWorkspaceID] = useState(null);
  const navigate = useNavigate();
  const params = useParams();
  
  // Safely decode workspaceID with error handling
  useEffect(() => {
    if (params.id) {
      try {
        const decoded = atob(params.id);
        setWorkspaceID(decoded);
      } catch (error) {
        console.error("Invalid access link:", error);
        setError("Invalid access link. Please contact your administrator.");
        setLoading(false);
        setTimeout(() => navigate("/"), 3000);
      }
    } else {
      setError("Invalid access link. Please contact your administrator.");
      setLoading(false);
      setTimeout(() => navigate("/"), 3000);
    }
  }, [params.id, navigate]);

  useEffect(() => {
    if (userStatus && userStatus.payload) {
      try {
        setUser(JSON.parse(userStatus.payload));
      } catch (error) {
        console.error("Error parsing user data:", error);
        setError("Error loading user data. Please try again.");
        setLoading(false);
      }
    } else {
      // User not authenticated yet - wait a bit or redirect
      setLoading(true);
    }
  }, [userStatus]);

  useEffect(() => {
    if (user && user.uid && user.email && workspaceID) {
      let tempEmail = user.email.replace(/[.@]/g, "-");
      setEmailRef(tempEmail);
    }
  }, [user, workspaceID]);

  useEffect(() => {
    // Fixed: proper condition check (was using comma operator incorrectly)
    if (emailRef && workspaceID && user && user.uid && user.email) {
      setLoading(true);
      get(ref(db, "userData/" + workspaceID + "/users/" + emailRef))
        .then((snapshot) => {
          if (snapshot.exists()) {
            let data = snapshot.val();
            if (data.email === user.email) {
              if (!data.id) {
                update(
                  ref(db, "userData/" + workspaceID + "/users/" + emailRef),
                  { id: user.uid }
                );
                get(ref(db, "userData/" + user.uid + "/linked/"))
                  .then((snapshot) => {
                    if (snapshot.exists()) {
                      let tempLinked = snapshot.val();
                      for (let i in tempLinked) {
                        if (i === workspaceID) {
                          if (!tempLinked[i].selected) {
                            update(
                              ref(
                                db,
                                "userData/" +
                                  user.uid +
                                  "/linked/" +
                                  workspaceID
                              ),
                              { selected: true }
                            );
                          }
                        } else {
                          if (tempLinked[i].selected) {
                            update(
                              ref(db, "userData/" + user.uid + "/linked/" + i),
                              { selected: false }
                            );
                          }
                        }
                      }
                    } else {
                      // Set default permissions for new user link
                      // Using role: "read" for backward compatibility - permission utilities will convert to view access for all sections
                      update(
                        ref(
                          db,
                          "userData/" + user.uid + "/linked/" + workspaceID
                        ),
                        { key: workspaceID, role: "read", selected: true }
                      );
                    }
                    setLoading(false);
                    navigate("/");
                  })
                  .catch((error) => {
                    console.error("Error linking organization:", error);
                    setError("Error linking organization. Please try again.");
                    setLoading(false);
                  });
              } else {
                // User already linked
                setLoading(false);
                navigate("/");
              }
            } else {
              setError("Email mismatch. Please contact your administrator.");
              setLoading(false);
            }
          } else {
            setError("Access link not found. Please contact your administrator.");
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error accessing organization:", error);
          setError("Error accessing organization. Please try again.");
          setLoading(false);
        });
    }
  }, [emailRef, workspaceID, user, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return (
      <div>
        <p>{error}</p>
        <button onClick={() => navigate("/")}>Go to Home</button>
      </div>
    );
  }

  return null;
};

export default Access;
